import { useMutation, useQueryClient } from '@tanstack/react-query';
import { listingsApi } from '../api/listings';

interface ScrapeButtonProps {
  listingId: number;
  status: string | null;
}

export default function ScrapeButton({ listingId, status }: ScrapeButtonProps) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => listingsApi.scrapeDetails(listingId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['listing', String(listingId)] });
      queryClient.invalidateQueries({ queryKey: ['listings'] });
    },
  });

  const isRunning = status === 'in_progress' || status === 'pending';

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        mutation.mutate();
      }}
      disabled={isRunning || mutation.isPending}
      className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
        isRunning
          ? 'bg-yellow-100 text-yellow-700 cursor-not-allowed'
          : status === 'completed'
            ? 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            : status === 'failed'
              ? 'bg-red-100 text-red-700 hover:bg-red-200'
              : 'bg-green-100 text-green-700 hover:bg-green-200'
      }`}
      title={
        isRunning ? 'Aktualisierung läuft…'
          : status === 'completed' ? 'Erneut aktualisieren'
            : status === 'failed' ? 'Aktualisierung fehlgeschlagen — erneut versuchen'
              : 'Aktualisieren'
      }
    >
      {mutation.isPending || isRunning ? (
        <span className="flex items-center gap-1.5">
          <span className="animate-spin inline-block w-3 h-3 border-2 border-current border-t-transparent rounded-full" />
          Aktualisiere…
        </span>
      ) : status === 'completed' ? (
        'Erneut aktualisieren'
      ) : status === 'failed' ? (
        'Aktualisierung wiederholen'
      ) : (
        'Aktualisieren'
      )}
    </button>
  );
}
